export default "__VITE_PUBLIC_ASSET__c4e0f937__"